import { Utils } from "../../../../../../../services/utils.service";
import { DataCollection } from "../../../../../../infrastructure/datacollection";
import { DataContainerService } from "../../../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../../../infrastructure/enums";
import { TransportData } from "../../../../../../infrastructure/transportdata";

export class WorkGalleryFetchRequest {
    public static readonly FetchRequestType: string = "work_gallery_master_fetch_request";
  state_ids: number[] = [];
  work_gallery_ids: number[] = [];
 

    public MergeIntoTransportData = (td: TransportData) => {
        let coll = DataContainerService.GetInstance().GetOrCreateCollection(td.MainData, WorkGalleryFetchRequest.FetchRequestType) as DataCollection;
        coll.Entries.push(this);
    }

    public FormulateTransportData = () => {
        let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
        this.MergeIntoTransportData(td);

        return td;
    }
}

